import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/User/user';
import { AppContextService } from '../../../services/app-context.service';
import { RouteAuthorizationService } from '../../../services/authorization/route-authorization.service';

@Component({
	selector: 'eif-design-system-all',
	templateUrl: './design-system.component-all.html',
	styleUrls: ['./design-system.component-all.scss'],
	standalone: false,
})
export class DesignSystemAllComponent implements OnInit {
	public loggedUser: User | null = null;

	constructor(
		public appContext: AppContextService,
		private routeAuthorizationService: RouteAuthorizationService
	) {}

	ngOnInit(): void {
		this.appContext.getLoggedUserAsync().subscribe((userResult) => {
			this.loggedUser = userResult.Data;

			if (!this.loggedUser?.IsSystemAdmin) {
				this.routeAuthorizationService.routeOnUnauthorized();
			}
		});
	}
}
